// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__61ap7","card":"Card_card__YKvnS","heading":"Card_heading__8NPkT","subHeading":"Card_subHeading__SomVe","paragraph":"Card_paragraph__0+25f"};